import { useContext } from "react"
import { ServicesContext } from "../../context/ServicesContext"

export const useService = () => useContext(ServicesContext)
